// Pro-email validation — require a professional (work) email when creating an
// account or an enterprise. A "pro" email is any valid address whose domain is
// NOT a known free / consumer provider (Gmail, Yahoo, Outlook, ISP mailboxes…).
// Shared so every creation point behaves identically, front AND server: the
// self-serve signup uses it to decide between an immediate freemium account
// (pro domain) and a review queue (consumer domain).
// Duplicated verbatim to supabase/functions/_shared/pro-email.ts.
// KEEP THE TWO COPIES BYTE-IDENTICAL (sync test enforces this).

const FREE_EMAIL_DOMAINS = new Set<string>([
  // Google
  'gmail.com', 'googlemail.com',
  // Yahoo
  'yahoo.com', 'yahoo.fr', 'yahoo.co.uk', 'yahoo.es', 'yahoo.de', 'yahoo.it', 'yahoo.ca', 'yahoo.co.in',
  'ymail.com', 'rocketmail.com',
  // Microsoft
  'hotmail.com', 'hotmail.fr', 'hotmail.co.uk', 'hotmail.it', 'hotmail.es', 'hotmail.de',
  'outlook.com', 'outlook.fr', 'live.com', 'live.fr', 'msn.com',
  // Apple
  'icloud.com', 'me.com', 'mac.com',
  // Autres internationaux
  'aol.com', 'gmx.com', 'gmx.net', 'gmx.fr', 'gmx.de',
  'proton.me', 'protonmail.com', 'pm.me',
  'yandex.com', 'yandex.ru', 'mail.com', 'mail.ru', 'zoho.com',
  'qq.com', '163.com', '126.com', 'sina.com', 'naver.com',
  // FAI / boîtes perso françaises
  'orange.fr', 'wanadoo.fr', 'free.fr', 'sfr.fr', 'laposte.net', 'bbox.fr', 'neuf.fr', 'aliceadsl.fr',
]);

/** Domaine en minuscules, ou '' si l'adresse n'a pas un format valide. */
export function extractEmailDomain(email: string): string {
  const m = String(email || '').trim().toLowerCase().match(/^[^\s@]+@([^\s@]+\.[^\s@]+)$/);
  return m ? m[1] : '';
}

/** true si l'email appartient à un fournisseur grand public connu. */
export function isFreeEmailDomain(email: string): boolean {
  const d = extractEmailDomain(email);
  return !!d && FREE_EMAIL_DOMAINS.has(d);
}

/** Email "pro" = format valide ET domaine non grand public. */
export function isProEmail(email: string): boolean {
  const d = extractEmailDomain(email);
  return !!d && !FREE_EMAIL_DOMAINS.has(d);
}

/** Message d'erreur (FR) partagé par les points de création. */
export const PRO_EMAIL_ERROR = 'Veuillez utiliser une adresse email professionnelle (pas Gmail, Yahoo, Outlook, etc.).';
